/* eslint-disable no-console */
// https://dev.to/andyhaskell/build-a-basic-web-app-with-indexeddb-38ef
// How to store on objectStore creation?
// https://stackoverflow.com/questions/33709976/uncaught-invalidstateerror-failed-to-execute-transaction-on-idbdatabase-a

// import { initialActivityTypesData } from './data/initialActivityTypesData'
// import { initialNotesData } from './data/initialNotesData'
import checkIfUpdateIsNeeded from './updates/update_v1'
// import checkIfUpdateIsNeededForVersion2 from '../../_BU/update_v2'
// import checkIfUpdateIsNeededForVersion4 from '../../_BU/update_v3'
// import checkIfUpdateIsNeededForVersion5 from './updates/update_v5'
import checkIfUpdateIsNeededForVersion2 from './updates/update_v2'

import addStorePresets from './reAddStoreData'

// TODO: Add table for: activities, Keys for map APIs (esp reverse coding)
let GeoMoverDB = {}
const version = 62

GeoMoverDB = {
  db: null,
  openDBRequest: null,

  /**
   * ----- CRUD methods to be used with the "settings" store ONLY!!!
   *
   * @param {*} obj Object that holds 2 params:
   *    [string] feature (any of "enableHighAccuracy","timeout","maximumAges","addressService")
   *    [bool|string] value (for toggles like "enableHighAccuracy" itis a boolean, others are strings)
   *
   * @example
   * const updatedSettingsData = GeoMoverDB.updateOneSetting({
   *   feature: 'enableHighAccuracy',
   *   value: bool
   * })
   */
  updateOneSetting (obj) {
    // console.log('GEOMOVERDB::updateOneSetting this.db =', this.db)
    // console.log('GEOMOVERDB::updateOneSetting obj =', obj)

    return new Promise((resolve, reject) => {
      // Start a database transaction and get the notes object store
      const tx = this.db.transaction(['settings'], 'readwrite')
      const settingsStore = tx.objectStore('settings')
      const cursorRequest = settingsStore.openCursor()

      cursorRequest.onsuccess = e => {
        const cursor = e.target.result
        // console.log('GEOMOVERDB::updateOneSetting:cursorRequest cursor =', cursor)

        if (cursor) {
          const itemToUpdate = cursor.value
          // console.log('GEOMOVERDB::updateOneSetting:cursorRequest itemToUpdate =', itemToUpdate)
          itemToUpdate[obj.feature] = obj.value
          itemToUpdate.lastUpdated = Date.now()

          const updateRequest = cursor.update(itemToUpdate)

          updateRequest.onsuccess = e => {
            resolve(true)
          }

          updateRequest.onerror = e => {
            // console.log('Update error happened: e =', e)
            reject(new Error(e))
          }
        }
      }

      cursorRequest.onerror = e => {
        console.log('cursorRequestError =', e)
      }
    })
  },

  getOneSetting (which) {
    // console.log('GEOMOVERDB::getOneSetting which =', which)
    return new Promise((resolve, reject) => {
      const tx = this.db.transaction('settings', 'readonly')
      const settingsStore = tx.objectStore('settings')
      const cursorRequest = settingsStore.openCursor()

      cursorRequest.onsuccess = e => {
        const cursor = e.target.result

        if (cursor) {
          // cursor.value
        }
      }
    })
  },

  getAllSettings () {
    return new Promise((resolve, reject) => {
      const tx = this.db.transaction('settings', 'readonly')
      const settingsStore = tx.objectStore('settings')
      const cursorRequest = settingsStore.openCursor()

      cursorRequest.onsuccess = e => {
        const cursor = e.target.result

        if (cursor) {
          resolve(cursor.value)
        }
      }

      cursorRequest.onerror = e => {
        reject(e)
      }
    })
  },

  /**
   * ----- CRUD Methods for other stores, not settings
   */

  addOne (store, data) {
    console.log('data =', data)
    return new Promise((resolve, reject) => {
      let addOperationStatus = false
      let errorMsg = ''
      let newActivityId = null

      // Start a database transaction and get the notes object store
      const tx = this.db.transaction([store], 'readwrite')
      const objStore = tx.objectStore(store)

      // Add the data to the object store (or put)
      // A request returns an onsuccess handler, from there we get the
      // newly created id, which we neewd for the vuex store-saved instance
      const req = objStore.add(data)
      req.onsuccess = e => {
        // console.log('req success! e =', e.target)
        addOperationStatus = true
        newActivityId = e.target.result
      }

      req.onerror = error => {
        addOperationStatus = false
        errorMsg = error
        // console.log('req error =', error)
      }

      // Wait for the database transaction to complete
      // A transaction has an oncomplete event, but NOT an onsuccess! (==> see request)
      tx.oncomplete = result => {
        // console.log('IDB addOne: return success from oncomplete. result =', result)
        if (addOperationStatus) {
          resolve(newActivityId)
        }
        else {
          resolve(errorMsg)
        }
      }

      tx.onerror = e => {
        // console.log('IDB addOne: return error from onerror:', e)
        reject(e)
      }
    })
  },

  updateOne (store, newData, key) {
    // console.log('GeoMoverDB: updateOne data =', newData)
    // console.log('> key =', key)
    return new Promise((resolve, reject) => {
      if (newData) {
        const tx = this.db.transaction([store], 'readwrite')
        const objStore = tx.objectStore(store)
        const req = objStore.get(key)

        // First get existing item...
        req.onsuccess = e => {
          // Fetch existing data
          const currentData = e.target.result
          // add new data
          Object.assign(currentData, newData)

          // Second update existing item...
          const updateRequest = objStore.put(currentData)
          updateRequest.onsuccess = () => {
            resolve(true)
          }
          updateRequest.onerrror = err => {
            reject(new Error(err))
          }
        }
        req.onerror = err => {
          reject(new Error('Could not open the DB on updateOne, error =', err))
        }
      }
      else {
        reject(new Error('GeoMoverDB: updateOne - No newData or key given. Did you select an item? Is the key a number (correct) or string (wrong)?'))
      }
    })
  },

  deleteOne (store, itemid) {
    // console.log('itemid =', itemid)

    return new Promise((resolve, reject) => {
      const tx = this.db.transaction([store], 'readwrite')
      const objStore = tx.objectStore(store)
      const req = objStore.openCursor()

      req.onsuccess = e => {
        const cursor = e.target.result

        if (cursor) {
          if (cursor.value.id === itemid) {
            // console.log('Found specific entry with id ', itemid)
            const deleteRequest = cursor.delete(itemid)

            deleteRequest.onsuccess = e => {
              // console.log('Deleted entry with id', itemid)
              // console.log('e =', e)
              resolve(e)
            }

            deleteRequest.onerror = e => {
              // console.log('There was an error deleting entry with id', itemid)
              reject(e)
            }
          }
          else {
            // didn't find proper result, continue searching
            cursor.continue()
          }
        }
      }

      req.onerror = e => {
        reject(e)
      }
    })
  },

  findOne (store, id) {
    return new Promise((resolve, reject) => {
      const tx = this.db.transaction([store], 'readonly')
      const objStore = tx.objectStore(store)
      const req = objStore.get(parseInt(id)) // id must be cast to number!

      req.onsuccess = e => {
        resolve(req.result)
      }

      req.onerror = e => {
        reject(new Error('GeoMoverDB\'s "findOne" on store ' + store + ' width id ' + id + ' did not yield a result'))
      }
    })
  },

  findAll (store, index = null, dir = 'asc') {
    return new Promise((resolve, reject) => {
      const tx = this.db.transaction([store], 'readonly')
      const objStore = tx.objectStore(store)

      const allEntries = []
      let index = null
      let req = null
      let sortingDirection = null

      if (dir === 'asc') {
        sortingDirection = 'next'
      }
      else {
        sortingDirection = 'prev'
      }

      // Create Cursor Request depending on whether we have an index to sort after or not
      if (index === null) {
        req = objStore.openCursor(null, sortingDirection)
      }
      else {
        index = objStore.index('timestamp')
        req = index.openCursor(null, sortingDirection)
      }

      req.onsuccess = e => {
        // The result of req.onsuccess in openCursor requests is an IDBCursor
        const cursor = e.target.result

        if (cursor !== null) {
          allEntries.push(cursor.value)
          // jumps back to onsuccess
          cursor.continue()
        }
        else {
          resolve(allEntries)
        }
      }

      req.onerror = e => {
        reject(new Error(e))
      }
    })
  },

  async findSelection (store, indexOfStore = null, dir = 'asc', limit = 5, offset = 0) {
    // console.groupCollapsed('findSelection of store "' + store.toUpperCase() + '"')
    // console.log('> indexOfStore =', indexOfStore)
    // console.log('> dir =', dir)
    // console.log('> limit =', limit)
    // console.log('> offset =', offset)

    return new Promise((resolve, reject) => {
      const tx = this.db.transaction([store], 'readonly')
      const objStore = tx.objectStore(store)

      const foundEntries = []
      let index = indexOfStore
      let req = null
      let sortingDirection = null

      // Calculate inital offset
      const forwardCursorPosition = limit * offset
      // Since there is a loop, when fetching more than one item, we
      // need to make sure, that "advance" is only called once
      let advanced = false
      // Number of items we already got, must not be more then limit
      let counter = 0

      if (dir === 'asc') {
        sortingDirection = 'next'
      }
      else {
        sortingDirection = 'prev'
      }
      // console.log('> sortingDirection =', sortingDirection)

      // Create Cursor Request depending on whether we have an index to sort after or not
      if (index === null) {
        // console.log('index = 0')
        req = objStore.openCursor(null, sortingDirection)
      }
      else {
        // console.log('> index =', index)
        index = objStore.index(index)
        req = index.openCursor(null, sortingDirection)
      }

      req.onsuccess = e => {
        // The result of req.onsuccess in openCursor requests is an IDBCursor
        const cursor = e.target.result

        // Forward cursor
        if (forwardCursorPosition !== 0 && !advanced) {
          cursor.advance(forwardCursorPosition)
          // Set advanced to true so this won't happen again in the current loop
          advanced = true
          // And quit!!! Importnat!
          return
        }

        if (cursor !== null && counter < limit) {
          counter++
          foundEntries.push(cursor.value)
          // jumps back to onsuccess
          cursor.continue()
        }
        else {
          resolve(foundEntries)
        }
      }

      req.onerror = e => {
        reject(new Error(e))
      }

      // console.groupEnd()
    })
  },

  // if ('getAll' in objectStore) { , @src: https://googlechrome.github.io/samples/idb-getall/
  getLastId (store) {
    return new Promise((resolve, reject) => {
      const tx = this.db.transaction([store], 'readonly')
      const objStore = tx.objectStore(store)
      const cursorRequest = objStore.openCursor(null, 'prev')

      cursorRequest.onsuccess = e => {
        // In case the DB was completely empty, the result is null
        if (e.target.result !== null && e.target.result.key) {
          resolve(e.target.result.key)
        }
        else {
          resolve(0)
        }
      }

      cursorRequest.onerror = e => {
        reject(new Error(e))
      }
    })
  },

  /*******************************
   * For Pagination
   *******************************/

  async getTotalCount (store) {
    // console.log('GeoMoverDB: getTotalcount - invoked; store =', store)
    return new Promise((resolve, reject) => {
      // console.log('> Created promise')
      const tx = this.db.transaction([store], 'readonly')
      const objStore = tx.objectStore(store)
      const req = objStore.count()

      req.onsuccess = e => {
        // console.log(`> Total entries in store >${store}<: ${e.target.result}`)
        resolve(e.target.result)
      }

      req.onerror = error => {
        reject(new Error(`> Could not retrieve a count on store ${store}. Error: ${error}`))
      }
    })
  },

  /*******************************
   * Add preset to selected store
   *******************************/

  async reAddStoreData (store) {
    return await addStorePresets(this.db, store)
  },

  /**
   * Start the IDB
   */
  init () {
    return new Promise((resolve, reject) => {
      this.openDBRequest = indexedDB.open('GeoMoverDB', version)

      // make this async?
      this.openDBRequest.onupgradeneeded = async (e) => {
        console.log('Create / Update GeoMoverDB')
        console.log('e.oldVersion', e.oldVersion)
        console.log('e.newVersion', e.newVersion)

        // Initial "Update" script
        // second param "version" needed to handle "updateoneSettingAfterUpdate" script
        await checkIfUpdateIsNeeded(e, version)

        // Update Scrits needed later on...
        if (e.newVersion > 1) {
          // second param "version" needed to handle "updateoneSettingAfterUpdate" script
          await checkIfUpdateIsNeededForVersion2(e, version)
        }

        // if (e.newVersion > 2) {
        //   await checkIfUpdateIsNeededForVersion4(e, version)
        // }

        // if (e.newVersion > 4) {
        //   await checkIfUpdateIsNeededForVersion5(e, version)
        // }

        // if (e.newVersion > 16) {
        //   // second param "version" needed to handle "updateoneSettingAfterUpdate" script
        //   await checkIfUpdateIsNeededForVersion38(e, version)
        // }
      }

      this.openDBRequest.onsuccess = e => {
        this.db = e.target.result

        // In case the db is old, close it and tell the user to update
        // @see https://javascript.info/indexeddb and below
        this.db.onversionchange = function () {
          this.db.close()

          reject(alert('Database is outdated, please reload the page.'))
        }

        resolve(true)
      }

      this.openDBRequest.onerror = e => {
        alert('error opening database ' + e.target.errorCode)
        resolve(false)
      }

      this.openDBRequest.onblocked = function () {
        // this event shouldn't trigger if we handle onversionchange correctly
        // it means that there's another open connection to same database
        // (which could happen, when the app is opened in 2 windows, one with
        // v1, another one with v2 – rarly but could happen in the course
        // of an update process...) and it wasn't closed after db.onversionchange
        // triggered for it
      }
    })
  }

}

export default GeoMoverDB
